import { SERVICES } from "@/data/site";

const items = SERVICES.map((s) => s.name);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-bronze/10 bg-alabaster py-5 select-none"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {items.map((name) => (
            <span key={`${copy}-${name}`} className="flex items-center">
              <span className="font-serif text-lg sm:text-xl italic text-ink/70 px-8 whitespace-nowrap">
                {name}
              </span>
              <span className="w-1.5 h-1.5 rotate-45 bg-gold shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
